import { UserPIN } from '@flowwai-frontend/shared-web/iam/data-access'
import { getErrorMessageFromErrorType } from '@flowwai-frontend/shared/utils/common'

import { SetUserPinMutation as Mutation } from './mutation.generatedTypes'

interface ResponseArgsType {
   data: Mutation
   onFailure?: (errorMessage: string, data: Mutation['setUserPin']) => void
   onSuccess?: (userPIN: UserPIN) => void
}

interface ReturnType {
   handleAPIResponse: (args: ResponseArgsType) => void
}

const useAPIResponseHandler = (): ReturnType => {
   const handleAPIResponse = (args: ResponseArgsType): void => {
      if (!args.data) return
      const { setUserPin } = args.data

      switch (setUserPin.__typename) {
         case 'SetUserPinResult': {
            const userPIN: UserPIN = {
               isPINConfigured: true,
               generatedOn: new Date(setUserPin.lastChangedAt ?? ''),
               expiresOn: new Date(setUserPin.expiresAt ?? '')
            }

            args.onSuccess?.(userPIN)
            break
         }
         case 'OTPVerificationRequired':
         case 'PinComplexityValidationFailed':
         case 'PinMatchesPreviousPin':
         default: {
            const errorType = setUserPin.__typename
            const errorMessage = getErrorMessageFromErrorType(errorType)

            args.onFailure?.(errorMessage, setUserPin)
         }
      }
   }
   return { handleAPIResponse }
}

export default useAPIResponseHandler
